// extracted by mini-css-extract-plugin
export default {"tooltip":"mN-z","arrow":"nN-z"};